<template>
    <div class="program-data-table">
        <div class="program-wrapper program-scroll"  v-if="activeProgramData && activeProgramData.length > 0">
            <div v-for="(program, i) in activeProgramData"  :key="i" class="program-single-box d-flex hand" :style="[{left: `${program.left}px`}, {width: `${program.width}px`}]" 
                :id="isCurrentProgram(program) ? 'currentProgram' : 'program'" :title="program.title + ' | ' + getFormatStartEndTime(program) + (program.episodetitle ? ' | ' + program.episodetitle : '') + (program.allgenre ? ' | ' + program.allgenre : '')">
                <button class="aligned-box" :style="[{width: `${program.width - 5}px`}]" 
                    :disabled="decideProgramColor(program) == 'disableProgram'"
                    :class="decideProgramColor(program)"
                     @click="actProgramPlay(program)">
                    <div class="ProgramTitle">{{ program.title }}</div>
                    <div class="ProgramText">
                        <!-- <span>{{ getFormatStartEndTime(program)}}</span> -->
                        <!-- <span  v-if="program.allgenre || program.episodetitle" style="font-weight: 100; font-size: 15px;" > | </span> -->
                        <span v-if="program.episodetitle" >{{ program.episodetitle }}</span>
                        <span v-else>{{ program.allgenre }}</span>
                    </div>
                    <!-- <div class="flex-item_catchup" id="live-item-catchup" v-if="isCurrentProgram(program)">▷ LIVE</div> -->
                </button>
            </div>
        </div>                        
        <div v-else-if="activeProgramData && activeProgramData.length <= 0" class="program-wrapper load-wrapper">
           <div key="loadWrapper" class="program-single-box d-flex hand" :style="[{left: `0px`}, {width: `100%`}]">
                <div class="aligned-box">
                    <div class="ProgramTitle">NO PROGRAMS AVAILABLE</div>
                    <div class="ProgramTitle">NO PROGRAMS AVAILABLE</div>
                    <div class="ProgramTitle">NO PROGRAMS AVAILABLE</div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { mapActions } from 'vuex';
    import { eventBus } from "@/eventBus";
    import moment from "moment";
    import PlaybackUtilities from "@/mixins/playbackUtilities.js";
    import Redirection from '@/mixins/redirection.js';
    export default {
        data() {
            return {
                activeProgramData: null,
                isLiveContentAccessError: false,
                isSyncingScroll: false,
                currentTime: moment.utc().local().valueOf(),
                timer: null
            }
        },
        watch: {
            selectedDate(newVal, oldVal) {
                if(newVal)
                this.actionToPickActiveProgramsOFSelectedChannelANDSelectedDate(this.channel, this.channelIndex, newVal)
            }
        },
        props:['channel', 'channelIndex', 'selectedDate', 'programsData'],
        mounted() {
            this.updateTime(); // set initial time
            this.timer = setInterval(this.updateTime, 30000); // update every 30 seconds
            this.actionToPickActiveProgramsOFSelectedChannelANDSelectedDate(this.channel, this.channelIndex, this.selectedDate);
        },
        computed: {
        },
        methods: {
            ...mapActions(['mapEpgXmlData', 'getContent']),
            actionToPickActiveProgramsOFSelectedChannelANDSelectedDate(channel, i, selectedDate) {
                this.activeProgramData = null; // Reset active program data
                let selectedStartDate = moment.utc(moment(selectedDate + " 00:00:00")).local().valueOf();
                let selectedEndDate = moment.utc(moment(selectedDate + " 24:00:00")).local().valueOf();
                let pxPerMinute = 5;
                this.sortedProgramsData(channel).then((res) => {
                    if (res.length > 0) {
                        const filteredPrograms = res.filter((item) => {
                            // Ensure the channel matches
                            const isChannelMatch = item.channel === channel.id;
                            // Ensure the date falls within the selected range
                            const programStart = moment.utc(moment(item.start, "YYYYMMDDHHmmss Z")).local().valueOf();
                            const programStop = moment.utc(moment(item.stop, "YYYYMMDDHHmmss Z")).local().valueOf();
                            const isDateMatch = programStart >= selectedStartDate && programStop <= selectedEndDate;
                            return isChannelMatch;
                        });
                        // Deduplicate results based on unique program attributes
                        let ffProgramData = filteredPrograms.filter((item, index, self) => {
                            return index === self.findIndex((t) => (
                                t.channel === item.channel &&
                                t.start === item.start &&
                                t.stop === item.stop &&
                                t.title === item.title
                            ));
                        });
                        this.activeProgramData = ffProgramData?.map((singleProgram, i) => {
                        const programStart = moment.utc(moment(singleProgram.start, "YYYYMMDDHHmmss Z")).local().valueOf();
                        const programStop = moment.utc(moment(singleProgram.stop, "YYYYMMDDHHmmss Z")).local().valueOf();
                        const startTime = moment.utc(singleProgram.start, "YYYYMMDDHHmmss Z").local();
                        const endTime = moment.utc(singleProgram.stop, "YYYYMMDDHHmmss Z").local();

                        let startTotalMinutes = startTime.hours() * 60 + startTime.minutes();
                        let endTotalMinutes = endTime.hours() * 60 + endTime.minutes();

                        let left = startTotalMinutes * pxPerMinute;
                        let width = (endTotalMinutes - startTotalMinutes) * pxPerMinute;
                        if(programStart < selectedStartDate){
                            left = 0;
                            width = endTotalMinutes * pxPerMinute;
                        }else {
                            // Handle midnight end (i.e., 00:00 on next day)
                            if (endTotalMinutes <= startTotalMinutes) {
                                endTotalMinutes += 24 * 60; // Treat as 24:00
                                left = startTotalMinutes * pxPerMinute;
                                width = (endTotalMinutes - startTotalMinutes) * pxPerMinute;
                            }
                        }
                        singleProgram.left = left;
                        singleProgram.width = width;
                        return singleProgram;
                    });  
                    } else {
                        this.activeProgramData = [];
                    }
                }).catch((err) => {
                    console.error("Error fetching program data:", err);
                    this.activeProgramData = [];
                });

            },
            sortedProgramsData(channel) {
                let filterData = [];
                return new Promise((resolve, reject) => {
                    try {
                        let singleData = this.programsData?.filter((item, i) => {
                            return item?.channel == channel?.id;
                        });
                        if (singleData) {
                            filterData = singleData?.sort((a, b) => (moment.utc(moment(a.start, "YYYYMMDDHHmmss Z")).local().valueOf()) - (moment.utc(moment(b.start, "YYYYMMDDHHmmss Z")).local().valueOf()));
                        }
                        resolve(filterData);
                    } catch (error) {
                        resolve(filterData);
                    }
                })
            },
            getFormatStartEndTime(item) {
                let startTime = moment.utc(moment(item.start, "YYYYMMDDHHmmss Z")).local().format("YYYY-MM-DD HH:mm:ss");
                startTime = moment(startTime).format("HH:mm");
                let endTime  = moment.utc(moment(item.stop, "YYYYMMDDHHmmss Z")).local().format("YYYY-MM-DD HH:mm:ss");
                endTime = moment(endTime).format("HH:mm");
                return startTime + ' - ' + endTime;
            },
            isCurrentProgram(item) {
                let startTime = moment.utc(moment(item.start, "YYYYMMDDHHmmss Z")).local().valueOf();
                let endTime = moment.utc(moment(item.stop, "YYYYMMDDHHmmss Z")).local().valueOf();
                return (startTime <= this.currentTime) && (this.currentTime <= endTime);
            },
            isFutureProgram(item) {
                let currentTime = moment().utc().local().valueOf();
                let startTime = moment.utc(moment(item.start, "YYYYMMDDHHmmss Z")).local().valueOf();
                return startTime > currentTime;
            },
            actProgramPlay(program) {
                let data = {
                    program: program,
                    channel: this.channel,
                }
                if(this.isCurrentProgram(program)) {
                    data.program['isLive'] = true;
                } else if (this.isFutureProgram(program)) {
                    data.program['isLive'] = true;
                } else {
                    data.program['isCatchUp'] = true;
                }
                console.log('dataa', data)
                this.$emit('actSelectedProgram', data);
            },
            updateTime() {
                this.currentTime = moment.utc().local().valueOf();
            },
            decideProgramColor(program) {
                let catchupperiod = this.channel.catchupperiod;
                if(this.isFutureProgram(program)) {
                    return "futureProgram";
                } else if(this.isCurrentProgram(program)){
                    return "currentProgram, active";
                } else if(this.isInPastHours(program, catchupperiod)) {
                    return "catchupProgram";
                } else {
                    return "disableProgram";
                }
            },
            isInPastHours(item, hours) {
                const currentTime = moment().utc().local().valueOf(); // Now
                const pastTime = moment().utc().subtract(hours, 'hours').local().valueOf(); // Now - N hours
                const startTime = moment.utc(moment(item.start, "YYYYMMDDHHmmss Z")).local().valueOf();

                return startTime >= pastTime && startTime <= currentTime;
            }
        },
        beforeDestroy() {
            clearInterval(this.timer);
        },
        mixins: [PlaybackUtilities, Redirection],
    }
</script>
<style lang="scss" scoped>
@import "@/sass/_variables.scss";
.program-data-table {
    width: 100%;
    height: 80px;
    // overflow:auto;
    .program-wrapper {
        width: 7200px;
        height: 100%;
        position: relative;
        flex-direction: row;
        overflow: hidden;
        .program-single-box {
            // overflow-x: auto;
            height: 100%;
            position: absolute;
            top:0;
            /* background: linear-gradient(to right, #1a202c, #1a202c); */
            border-radius: 8px;
            display: flex;
            -webkit-justify-content: flex-start;
            justify-content: flex-start;
            .aligned-box {
                    position: relative;
                    display: flex;
                    flex-direction: column;
                    font-size: 11px;
                    height: calc(100% - 10px);
                    margin: auto;
                    border-radius: 8px;
                    padding: 10px 20px;
                    // overflow: hidden;
                    cursor: pointer;
                    -webkit-transition: all 0.4s ease-in-out;
                    transition: all 0.4s ease-in-out;
                    background: linear-gradient(to right, #1a202c, #1a202c);
                    z-index: 1;
                    justify-content: center;
                    &:hover {
                        /* background: linear-gradient(to right, #051937, #002360, #002eb3); */
                        // background: linear-gradient(to right, #df6915, #c27321, #b35000);
                        background: $primary-btn-color;
                        .ProgramText, .ProgramTitle {
                            color: #FFFFFF;
                        }
                    }
                    .ProgramTitle {
                        font-size: 14px;
                        text-align: left;
                        margin-top: 0;
                        margin-bottom: 5px;
                        font-weight: 500;
                        color: #ffff;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                    }
                    .ProgramText {
                        display: block;
                        font-size: 12.5px;
                        font-weight: 400;
                        color: #718096;
                        text-align: left;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                    }
            }

            .active {
                /* background: linear-gradient(to right, #051937, #002360, #002eb3); */
                // background: linear-gradient(to right, #df6915, #c27321, #b35000);
                //  background: $primary-btn-color;
                background: #454242ed;
                .ProgramText, .ProgramTitle {
                    color: #FFFFFF;
                }
            }
        }
    }
    .load-wrapper {
        .program-single-box {
            .aligned-box {
                width: calc(100% - 5px);
                height: calc(100% - 10px);
                margin: auto;
                display: flex;
                flex-direction: row;
                justify-content:space-between;
                align-items: center;
                &:hover {
                    /* background: linear-gradient(to right, #051937, #002360, #002eb3); */
                    background: linear-gradient(to right, #1a202c, #1a202c);
                    .ProgramText, .ProgramTitle {
                        color: #FFFFFF;
                    }
                }
                .ProgramTitle {
                    margin: 0 !important;
                }
            }
        }
    }
}
.futureProgram {
    background: rgba(46, 46, 46, 1) !important;
    // .ProgramTitle, .ProgramText {
    //     color: yellow !important;
    // }
}
.currentProgram {
    background: rgba(77, 77, 77, 1) !important;
    // .ProgramTitle, .ProgramText {
    //     color: #FFFFFF !important;
    // }
}
.catchupProgram {
    background: rgba(31, 31, 31, 1) !important;
    // .ProgramTitle, .ProgramText {
    //     color: pink !important;
    // }
}
.disableProgram {
    background: #1d1d1d !important;
    // .ProgramTitle, .ProgramText {
    //     color: darkred !important;
    // }
}
button {
    border: none !important;
}
button:disabled {
    border: none !important;
    cursor: not-allowed !important;
    display: flex !important;
    align-items: flex-start !important;
}
</style>